import React, { useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import { FileDownload, Feedback, Business } from "@mui/icons-material";
import { useCompanyPageStore } from "../../../store/companyPageStore";
import { CompanyExportDialog } from "./CompanyExport/CompanyExportDialog";
import {
  useExportDisabledMessage,
  useExportVisibility,
} from "../../../hooks/useExportVisibility";

export const CompanyActionButtonsSkeleton: React.FC = () => {
  return (
    <Stack direction="row" spacing={1}>
      <Skeleton variant="rounded" width={80} height={30} />
      <Skeleton variant="rounded" width={140} height={30} />
      <Skeleton variant="rounded" width={160} height={30} />
    </Stack>
  );
};

export const CompanyActionButtons: React.FC = () => {
  const organizationViewOpen = useCompanyPageStore(
    (state) => state.organizationViewOpen
  );
  const toggleOrganizationView = useCompanyPageStore(
    (state) => state.toggleOrganizationView
  );
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const canExport = useExportVisibility();
  const exportDisabledMessage = useExportDisabledMessage();

  const handleExportClick = () => {
    setExportDialogOpen(true);
  };

  const handleExportDialogClose = () => {
    setExportDialogOpen(false);
  };

  return (
    <>
      <Tooltip title={!canExport ? exportDisabledMessage : ""}>
        <span>
          <Button
            data-testid="company-detail-export-btn"
            startIcon={<FileDownload />}
            variant="text"
            color="secondary"
            size="small"
            disabled={!canExport}
            onClick={handleExportClick}
          >
            EXPORT
          </Button>
        </span>
      </Tooltip>
      <Button
        data-testid="company-detail-org-view-toggle-btn"
        startIcon={<Business />}
        variant="text"
        color={organizationViewOpen ? "primary" : "secondary"}
        size="small"
        onClick={toggleOrganizationView}
      >
        ORGANIZATION VIEW
      </Button>
      <Button
        startIcon={<Feedback />}
        variant="text"
        color="secondary"
        size="small"
        href="https://support.hginsights.com/hc/en-us/requests/new"
        target="_blank"
        rel="noopener noreferrer"
      >
        GIVE FEEDBACK
      </Button>

      <CompanyExportDialog
        open={exportDialogOpen}
        onClose={handleExportDialogClose}
      />
    </>
  );
};
